module.exports = __webpack_public_path__ + "img/Speaker=Benjamin Sehl.62ae3051.png";